export default "/fonts/vendor/katex/dist/KaTeX_Typewriter-Regular.woff?4c6b94fd1d07f8beff7cf3364d4d4555";